import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateProvincePayload {
  country: string;
  code: string;
  name: string;
  status: number;
}

export interface UpdateProvincePaylod extends CreateProvincePayload {}

export const PROVINCE_QUERY_KEY = ["province"];
export const VIEW_PROVINCE_QUERY_KEY = ["view-province"];

export const provinceService = {
  createProvince: async (payload: CreateProvincePayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/province", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showProvince: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/province/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateProvince: async (id: number, payload: UpdateProvincePaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/province/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/province/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  getAllProvinces: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-province`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getProvinceByCountry: async (country: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/province/${country}/by-country`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
